import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Divider, IconButton, Label, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { useTextToSpeechContext } from 'widgets/TextToSpeech/context/context'
import {
  type ITextToSpeechActionsProps,
  TextToSpeechActions,
} from 'widgets/TextToSpeech/ui/TextToSpeechActions/TextToSpeechActions'
import { TextToSpeechText } from 'widgets/TextToSpeech/ui/TextToSpeechText/TextToSpeechText'
import {
  type ITextToSpeechInfoProps,
  TextToSpeechInfo,
} from 'widgets/TextToSpeech/ui/TextToSpeechInfo/TextToSpeechInfo'
import { type ISpeechToTextVariant } from 'widgets/TextToSpeech/store/type'
import styles from './styles.module.scss'

export type ITextToSpeechUiProps = {
  title?: string
  variant?: ISpeechToTextVariant
  actionsProps?: ITextToSpeechActionsProps
} & ITextToSpeechInfoProps
export const TextToSpeechUi = observer(
  ({
    title = 'Text to speech',
    variant = 'inline',
    actionsProps,
    ...infoProps
  }: ITextToSpeechUiProps) => {
    const { createTextToSpeechStoreProps, type, error } = useTextToSpeechContext()

    if (type === 'create') {
      return (
        <>
          <div
            className={classNames(styles.wrap, {
              [styles.modal]: variant === 'modal',
            })}
          >
            <div className={styles.header}>
              <Typography
                ariaLabel={getAriaLabel('TextToSpeech')}
                variant={'body-md-medium'}
                className={styles.title}
              >
                {title}
              </Typography>
              {createTextToSpeechStoreProps && (
                <IconButton
                  ariaLabel={getAriaLabel('cancel')}
                  icon={'close'}
                  variant={'icon'}
                  color={'tertiary'}
                  size={'small'}
                  onClick={createTextToSpeechStoreProps.onClose}
                />
              )}
            </div>
            <div className={styles.content}>
              <TextToSpeechText />
              <TextToSpeechInfo {...infoProps} />
              <TextToSpeechActions variant={variant} {...actionsProps} />
            </div>
          </div>
        </>
      )
    }
    if (type === 'view') {
      return (
        <div>
          {title && (
            <Label
              label={{
                text: title,
              }}
              marginBottom={4}
            />
          )}
          <div className={classNames(styles.view, { [styles.error]: error })}>
            <TextToSpeechText />
            <TextToSpeechInfo {...infoProps} />
            <Divider
              style={{ marginInline: '12px', borderColor: 'var(--interaction-neutral-normal)' }}
            />
            <TextToSpeechActions {...actionsProps} />
          </div>
        </div>
      )
    }
    // check for ts
    const check: never = type
    return null
  }
)
